<section class="mass-os-filters">
  <div class="mass-os-filters__file">
    <div class="mass-os-filters__file-copy">
      <h3>File</h3>
      <p>Escribe el número y elige una opción del listado.</p>
    </div>

    <mat-form-field
      appearance="outline"
      class="mass-os-filters__file-field mass-os-field"
      floatLabel="always"
    >
      <mat-label>N° de file</mat-label>
      <input
        type="text"
        matInput
        [formControl]="fileControl"
        [matAutocomplete]="autoFile"
        placeholder="Ej. 20037663"
        autocomplete="off"
      />
      <mat-icon matSuffix class="mass-os-field__icon">search</mat-icon>
      <mat-autocomplete
        #autoFile="matAutocomplete"
        [displayWith]="displayFileOption"
        (optionSelected)="fileSelected.emit()"
      >
        <mat-option
          *ngFor="let option of filteredOptions | async"
          [value]="option"
        >
          {{ option.fileNumber }}
          {{ option.fileExtend ? ' ' + option.fileExtend : '' }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <ng-content select="[massOsFileSummary]"></ng-content>

  <div class="mass-os-filters__panel" *ngIf="showServiceFilters">
    <div class="mass-os-filters__panel-head">
      <h3>Filtros de servicios</h3>
      <p>{{ filtersPanelHint }}</p>
    </div>

    <div class="mass-os-filters__grid">
      <mat-form-field appearance="outline" class="mass-os-field">
        <mat-label>Estado file</mat-label>
        <mat-select
          [value]="filters.estadoFile"
          (selectionChange)="onFilterFieldChange({ estadoFile: $event.value })"
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option *ngFor="let estado of fileStates" [value]="estado">
            {{ estado }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mass-os-field">
        <mat-label>Cliente</mat-label>
        <mat-select
          [value]="filters.client"
          (selectionChange)="onFilterFieldChange({ client: $event.value })"
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option *ngFor="let client of filterOptions.clients" [value]="client">
            {{ client }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mass-os-field">
        <mat-label>Día</mat-label>
        <mat-select
          [value]="filters.day"
          (selectionChange)="onFilterFieldChange({ day: $event.value })"
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option *ngFor="let day of filterOptions.days" [value]="day">
            {{ day }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mass-os-field">
        <mat-label>Servicio</mat-label>
        <mat-select
          [value]="filters.serviceName"
          (selectionChange)="onFilterFieldChange({ serviceName: $event.value })"
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option
            *ngFor="let service of filterOptions.services"
            [value]="service"
          >
            {{ service }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="mass-os-field"
        *ngIf="!hideTypeOfServiceFilter"
      >
        <mat-label>Tipo servicio</mat-label>
        <mat-select
          [value]="filters.typeOfService"
          (selectionChange)="
            onFilterFieldChange({
              typeOfService: $event.value,
              categoryOfService: null
            })
          "
        >
          <mat-option [value]="null">Todos</mat-option>
          <mat-option
            *ngFor="let tipo of filterOptions.typesOfService"
            [value]="tipo"
          >
            {{ tipo }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mass-os-field">
        <mat-label>Categoría</mat-label>
        <mat-select
          [value]="filters.categoryOfService"
          [disabled]="!hideTypeOfServiceFilter && !filters.typeOfService"
          (selectionChange)="
            onFilterFieldChange({ categoryOfService: $event.value })
          "
        >
          <mat-option [value]="null">Todas</mat-option>
          <mat-option *ngFor="let categoria of categoriesForTipo" [value]="categoria">
            {{ categoria }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="mass-os-field"
        *ngIf="!hideOrderNumberFilter"
      >
        <mat-label>N° OS</mat-label>
        <mat-select
          [value]="filters.orderNumber"
          (selectionChange)="onFilterFieldChange({ orderNumber: $event.value })"
        >
          <mat-option [value]="null">Todas</mat-option>
          <mat-option
            *ngFor="let orderNumber of filterOptions.orderNumbers"
            [value]="orderNumber"
          >
            {{ orderNumber }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="mass-os-filters__dates mass-os-field">
        <mat-label>Fecha del servicio</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input
            matStartDate
            placeholder="Inicio"
            [(ngModel)]="filters.startDate"
            (ngModelChange)="onFilterFieldChange({ startDate: $event })"
          />
          <input
            matEndDate
            placeholder="Fin"
            [(ngModel)]="filters.endDate"
            (ngModelChange)="onFilterFieldChange({ endDate: $event })"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel type="button">Cancelar</button>
            <button
              mat-button
              type="button"
              matDateRangePickerCancel
              (click)="clearDateRange.emit()"
            >
              Limpiar
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              matDateRangePickerApply
              (click)="onApplyDateRange()"
            >
              Filtrar
            </button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="mass-os-filters__search mass-os-field"
        floatLabel="always"
      >
        <mat-label>Buscar en grilla</mat-label>
        <input
          matInput
          [value]="searchValue"
          (input)="onSearch($any($event.target).value)"
          placeholder="Proveedor, servicio, OS…"
        />
        <mat-icon matSuffix class="mass-os-field__icon">manage_search</mat-icon>
      </mat-form-field>
    </div>
  </div>
</section>
